import { render, staticRenderFns } from "./linkageBox.vue?vue&type=template&id=1aa64b4b&scoped=true&"
import script from "./linkageBox.vue?vue&type=script&lang=js&"
export * from "./linkageBox.vue?vue&type=script&lang=js&"
import style0 from "./linkageBox.vue?vue&type=style&index=0&id=1aa64b4b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa64b4b",
  null
  
)

export default component.exports